import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import './metis-clog'
import './set-ca'
import { octopus } from './octopus'
import React from 'react'
import ReactDOM from 'react-dom'
import { HashRouter as Router } from 'react-router-dom'
import { MetisConfigProvider, MetisApp } from '@yuanfudao/metis-web-component'
import App from '@/App'
import dayjs from 'dayjs'
import { zhCN } from '@yuanfudao/metis-web-component/dist/locale'
import 'dayjs/locale/zh-cn'
import '@/styles/page-base.less'
import '@yuanfudao/metis-unified-login/es/styles/page-base.less'
import 'normalize.css'
import { RecoilRoot } from 'recoil'
import { loginEmitter, requestInterceptor, responseFulfilledInterceptor, responseInterceptor, getAccessToken, getRefreshToken, saveTokenToStorage } from '@yuanfudao/metis-unified-login'
import { axiosInstance as standardAxiosInstance } from '@yuanfudao/metis-standard-data'
import { isElectron } from './utils/os'
import { BridgeAppReady, bridgeData, BridgeLogout, BridgeUpdateToken } from './electron'
import config from '@yuanfudao/metis-unified-login/es/config'

octopus.init()

standardAxiosInstance.interceptors.request.use(
  requestInterceptor({
    setConfig(c) {
      c.baseURL = config.HTTP_BASE_URL + c.baseURL
      return {
        ...c,
        params: {
          ...c.params,
          // _selected_student_: 2112,
          // _selected_inst_: 94589,
        },
      }
    },
  }),
  (err) => Promise.reject(err),
)

standardAxiosInstance.interceptors.response.use(
  responseFulfilledInterceptor(),
  responseInterceptor(),
)

if (isElectron) {
  loginEmitter.on('saveTokenToStorage', ({ at, rt }) => {
    BridgeUpdateToken({ arguments: { accessToken: at, refreshToken: rt } })
  })
  loginEmitter.on('cleanLoginStorage', () => {
    BridgeLogout()
  })
  // 15s之后，无论如何都关闭electron的loading
  setTimeout(() => {
    if (isElectron && !bridgeData.bridgeAppReady) {
      BridgeAppReady()
    }
  }, 15000)
}

const at = getAccessToken()
const rt = getRefreshToken()
if (at) {
  saveTokenToStorage(at, rt)
}

dayjs.locale('zh-cn')

ReactDOM.render(
  <MetisConfigProvider hashPriority="high" locale={zhCN}>
    <Router>
      <RecoilRoot>
        <MetisApp>
          <App />
        </MetisApp>
      </RecoilRoot>
    </Router>
  </MetisConfigProvider>,
  document.getElementById('root'),
)
